import React from "react";
import { Box, Container, Typography, Link, IconButton, Grid } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import { useNavigate } from "react-router";

const Footer: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "var(--primary-color)",
        color: "white",
        mt: "auto",
        // pt: 6,
        pb: 3,
      }}
    >
      <Container maxWidth="lg">
        {/* <Grid container spacing={4}> */}
          {/* Company Info */}
          {/* <Grid size={{ xs: 12, md: 4 }}>
            <Typography
              variant="h6"
              sx={{ fontWeight: 600, mb: 2, color: "white" }}
            >
              Vehicle Maintenance
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, opacity: 0.8, lineHeight: 1.8 }}>
              Track and manage your vehicle service history efficiently.
              Never miss a maintenance deadline again.
            </Typography>
            <Box sx={{ display: "flex", gap: 1 }}>
              <IconButton
                size="small"
                href="https://facebook.com"
                target="_blank"
                sx={{ color: "white", "&:hover": { bgcolor: "rgba(255,255,255,0.1)" } }}
              >
                <FacebookIcon fontSize="small" />
              </IconButton>
              <IconButton
                size="small"
                href="https://twitter.com"
                target="_blank"
                sx={{ color: "white", "&:hover": { bgcolor: "rgba(255,255,255,0.1)" } }}
              >
                <TwitterIcon fontSize="small" />
              </IconButton>
              <IconButton
                size="small"
                href="https://instagram.com"
                target="_blank"
                sx={{ color: "white", "&:hover": { bgcolor: "rgba(255,255,255,0.1)" } }}
              >
                <InstagramIcon fontSize="small" />
              </IconButton>
            </Box>
          </Grid> */}

          {/* Quick Links */}
          {/* <Grid size={{ xs: 6, md: 2 }}>
            <Typography
              variant="h6"
              sx={{ fontWeight: 600, mb: 2, color: "white", fontSize: "1rem" }}
            >
              Quick Links
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Link
                component="button"
                onClick={() => navigate("/")}
                sx={{ color: "white", opacity: 0.8, textDecoration: "none", "&:hover": { opacity: 1 }, textAlign: 'left' }}
              >
                Home
              </Link>
              <Link
                component="button"
                onClick={() => navigate("/dashboard")}
                sx={{ color: "white", opacity: 0.8, textDecoration: "none", "&:hover": { opacity: 1 }, textAlign: 'left' }}
              >
                Dashboard
              </Link>
              <Link
                component="button"
                onClick={() => navigate("/service-history")}
                sx={{ color: "white", opacity: 0.8, textDecoration: "none", "&:hover": { opacity: 1 }, textAlign: 'left' }}
              >
                Service History
              </Link>
              <Link
                component="button"
                onClick={() => navigate("/add-vehicle")}
                sx={{ color: "white", opacity: 0.8, textDecoration: "none", "&:hover": { opacity: 1 }, textAlign: 'left' }}
              >
                Add Vehicle
              </Link>
            </Box>
          </Grid> */}

          {/* Services */}
          {/* <Grid size={{ xs: 6, md: 2 }}>
            <Typography
              variant="h6"
              sx={{ fontWeight: 600, mb: 2, color: "white", fontSize: "1rem" }}
            >
              Services
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Link
                component="button"
                onClick={() => navigate("/add-service")}
                sx={{ color: "white", opacity: 0.8, textDecoration: "none", "&:hover": { opacity: 1 }, textAlign: 'left' }}
              >
                Add Service
              </Link>
              <Link
                component="button"
                onClick={() => navigate("/contact")}
                sx={{ color: "white", opacity: 0.8, textDecoration: "none", "&:hover": { opacity: 1 }, textAlign: 'left' }}
              >
                Contact Us
              </Link>
              <Link
                component="button"
                onClick={() => navigate("/settings")}
                sx={{ color: "white", opacity: 0.8, textDecoration: "none", "&:hover": { opacity: 1 }, textAlign: 'left' }}
              >
                Settings
              </Link>
            </Box>
          </Grid> */}

          {/* Contact Info */}
          {/* <Grid size={{ xs: 12, md: 4 }}>
            <Typography
              variant="h6"
              sx={{ fontWeight: 600, mb: 2, color: "white", fontSize: "1rem" }}
            >
              Contact Us
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <HomeIcon sx={{ fontSize: 20, opacity: 0.8 }} />
                <Typography variant="body2" sx={{ opacity: 0.8 }}>
                  123 Vehicle Street, Auto City
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <EmailIcon sx={{ fontSize: 20, opacity: 0.8 }} />
                <Typography variant="body2" sx={{ opacity: 0.8 }}>
                  thinkworksolution@gmail.com
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <PhoneIcon sx={{ fontSize: 20, opacity: 0.8 }} />
                <Typography variant="body2" sx={{ opacity: 0.8 }}>
                  +1 (555) 123-4567
                </Typography>
              </Box>
            </Box>
          </Grid> */}
        {/* </Grid> */}

        {/* Divider */}
        <Box
          sx={{
            borderTop: "1px solid rgba(255,255,255,0.1)",
            my: 3,
          }}
        />

        {/* Copyright */}
        <Typography
          variant="body2"
          align="center"
          sx={{ opacity: 0.7, fontSize: "0.875rem" }}
        >
          © {new Date().getFullYear()} Vehicle Maintenance. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
